import { Box, styled } from '@mui/material';
import color from 'src/theme/color';

export const Container = styled(Box)`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
`;

export const RichTextEditor = styled('div')`
    margin-top: 20px;
`;

export const AttachmentsContainer = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    maxHeight: '150px',
    overflowY: 'auto',
    width: '100%',
    padding: '8px 0',
    marginTop: '16px'
});

export const AttachmentIconButton = styled(Box)({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '4px',
    marginRight: '4px'
});

export const HiddenFileInput = styled('input')({
    display: 'none'
});

export const ErrorMessage = styled(Box)({
    color: color.errorRed,
    fontSize: '12px',
    width: '100%',
    marginTop: '8px'
});
